import { SelectOption } from "@pulseops/common"

export namespace ServiceInquiryForCompletedCaseForm {
  export interface BasicSearchData {
    policyNumber: string
    clientNumber: string
    idNumber: string
    fromDate: Date
    toDate: Date
    source: SelectOption[]
    category: SelectOption
    transactionType: SelectOption[]
  }
}
